import React from 'react';
import { Col, Form, FormGroup, Row } from 'reactstrap';
import { InputText, SelectCustom } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { GatewayPrioritySequence } from '@/model/GatewayPrioritySequence';
import PaymentGateway from '@/model/PaymentGateway';
import { Plus, X } from 'react-feather';
import { FormInputName } from '../../types';

interface StateProps {
  paymentGateways: PaymentGateway[];
  formData: FormData;
  formErrors: FormErrors;
  sequences: GatewayPrioritySequence[];
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
  onChangeGateway: (index: number, paymentGatewayId: string) => void;
  onChangeSequence: (index: number, sequence: number) => void;
  onAddSequence: () => void;
  onRemoveSequence: (index: number) => void;
}

type Props = StateProps & DispatchProps;

export const RegisterContent: React.FC<Props> = ({
  paymentGateways,
  formData,
  formErrors,
  onChangeFormInput,
  sequences,
  onChangeGateway,
  onChangeSequence,
  onAddSequence,
  onRemoveSequence,
}): JSX.Element => {
  const gateways = paymentGateways.map(data => ({ label: data.name, value: data.id }));

  const paymentForms = [
    { label: 'Cartão de Crédito', value: '0' },
    { label: 'Cartão de Débito', value: '2' },
    { label: 'PIX', value: '3' },
    { label: 'Boleto', value: '4' },
  ];
  return (
    <Form
      noValidate={true}
      onSubmit={(e): void => {
        e.preventDefault();
      }}
    >
      <Row>
        <Col md={8}>
          <h5 className="mb-5 border-bottom-title">Informação de Tipo de Pagamento</h5>
          <FormGroup className="mb-2">
            <SelectCustom
              name="paymentType"
              label="Forma de pagamento"
              placeholder="Dinheiro, Cartão de Crédito, etc."
              value={formData[FormInputName.paymentType]}
              onChange={e => onChangeFormInput(FormInputName.paymentType)(e?.value as string)}
              error={formErrors.paymentType && formErrors.paymentType[0]}
              options={paymentForms}
            />
          </FormGroup>
          <h5 className="mb-5 border-bottom-title">Order Prioritária dos Gateways</h5>
          {sequences &&
            sequences.length > 0 &&
            sequences.map((data, index) => (
              <React.Fragment key={`Sequence-${index}`}>
                {index === 0 ? (
                  <Row>
                    <Col md={5} className="pl-0">
                      <FormGroup className="mb-2">
                        <SelectCustom
                          name="paymentGateway"
                          label="Gateway de pagamento"
                          placeholder="Digite ou selecione o gateway de pagamento"
                          onChange={e => {
                            onChangeGateway(index, e?.value as string);
                          }}
                          value={data.paymentGateway ? data.paymentGateway.id : ''}
                          options={gateways}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup className="mb-2">
                        <InputText
                          type="number"
                          name="sequence"
                          label="Prioridade"
                          placeholder="10"
                          max={5}
                          value={data.sequence?.toString() || ''}
                          onChange={e => onChangeSequence(index, Number(e.target.value))}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={1} className="pr-0">
                      <div style={{ paddingTop: '50px' }}>
                        <Plus className="svg-icon action-icon" onClick={onAddSequence} />
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col md={5} className="pl-0">
                      <FormGroup className="mb-2">
                        <SelectCustom
                          name="paymentGateway"
                          label="Gateway de pagamento"
                          placeholder="Digite ou selecione o gateway de pagamento"
                          onChange={e => {
                            onChangeGateway(index, e?.value as string);
                          }}
                          value={data.paymentGateway ? data.paymentGateway.id : ''}
                          options={gateways}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup className="mb-2">
                        <InputText
                          type="number"
                          name="sequence"
                          label="Prioridade"
                          placeholder="10"
                          max={5}
                          value={data.sequence?.toString() || ''}
                          onChange={e => onChangeSequence(index, Number(e.target.value))}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={1} className="pr-0">
                      <div style={{ paddingTop: '20px' }}>
                        <X
                          className="svg-icon action-icon"
                          onClick={() => onRemoveSequence(index)}
                        />
                      </div>
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            ))}
        </Col>
      </Row>
    </Form>
  );
};
